<template>
<svg class="h-4 w-4" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
	 viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
<g>
	<path d="M21.707,24.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l7.999,7.999c0.001,0.001,0.001,0.001,0.002,0.002
		L29,34.414l0.706-0.706c0.001-0.001,0.001-0.001,0.002-0.002l7.999-7.999c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0
		L30,30.586V3c0-0.552-0.447-1-1-1s-1,0.448-1,1v27.586L21.707,24.293z"/>
	<path d="M57.981,32.676L57.53,32h-0.009l-3.583-5.381l-2.421-3.628l0.004-0.002L47.535,17H36v2h10.465l8.679,13H39v7H19v-7H2.856
		l8.679-13H22v-2H10.465L0.431,32.031l-0.014,0.001L0,32.655v0.206v0.396v19.359C0,54.482,1.519,56,3.385,56h51.23
		C56.481,56,58,54.482,58,52.616V33.239v-0.429l-0.014-0.036L57.981,32.676z"/>
</g>

</svg>
</template>

<script>       
export default {
    name: "InboxIcon",
    props:{
        class: {
            type: String,
        },        
    },
}
</script>
